import "./NavbarTop.scss";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { IoLogoWhatsapp } from "react-icons/io";
import {
  MdLocationOn,
  MdOutlinePersonOutline,
  MdOutlineLanguage,
  MdRssFeed,
} from "react-icons/md";
import { WiDayCloudy } from "react-icons/wi";
import { BiCalendar } from "react-icons/bi";
import { RxCaretDown } from "react-icons/rx";
import { ImGooglePlus } from "react-icons/im";
import { FaYoutube } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { RiFacebookFill, RiTwitterFill } from "react-icons/ri";
import { useState } from "react";
import { AdminOnlyLink } from "../hiddenLink/AdminOnlyRoute";
import ShowOnLogin, { ShowOnLogout } from "../hiddenLink/hiddenLink";
import { useDispatch } from "react-redux";
import { logout, RESET_AUTH } from "../../redux/features/auth/authSlice";

const NavbarTop = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [fix, setFix] = useState(false);
  const [dropDown, setDropDown] = useState(false);

  const handleDropdown = () => {
    setDropDown(!dropDown);
  };

  const logoutUser = async () => {
    await dispatch(logout());
    await dispatch(RESET_AUTH());
    navigate("/login");
  };

  const handleScroll = (e) => {
    if (window.scrollY >= 200) {
      setFix(true);
    } else {
      setFix(false);
    }
  };

  window.addEventListener("scroll", handleScroll);

  const activeLink = ({ isActive }) => (isActive ? "active" : "");

  const date = new Date();

  let d = new Intl.DateTimeFormat("en-GB", {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "2-digit",
  })
    .format(date)
    .split(" ")
    .join("-");

  return (
    <div className={fix ? "navbarTop fixed" : "navbarTop"}>
      {/* <div className="navbarTop"> */}
      <div className="navbarContainer">
        <div className="right">
          <NavLink to="/">
            <div className="item">
              <span>Home</span>
            </div>
          </NavLink>

          <ShowOnLogout>
            <NavLink to="/login">
              <div className="item">
                <MdOutlinePersonOutline size={18} />
                <span>Login</span>
              </div>
            </NavLink>
          </ShowOnLogout>

          <ShowOnLogout>
            <NavLink to="/register">
              <div className="item">
                <span>Register</span>
              </div>
            </NavLink>
          </ShowOnLogout>

          <ShowOnLogin>
            <Link to="/" onClick={logoutUser}>
              <div className="item">
                <span>
                  <span>Logout</span>
                </span>
              </div>
            </Link>
          </ShowOnLogin>
          {/* <ShowOnLogin>
            <Link to="/profile">
              <FaUserCircle size={16} color="#ff7722" />
              <UserName />
            </Link>
          </ShowOnLogin> */}
          <div className="item language" onClick={handleDropdown}>
            <MdOutlineLanguage size={18} />
            <span>English</span>
            <RxCaretDown size={18} />
          </div>

          {/* <div className="icons">
            <RiFacebookFill size={18} />
            <RiTwitterFill size={18} />
            <ImGooglePlus size={18} />
            <FaYoutube size={18} />
          </div> */}

          {dropDown && (
            <ul className="dropDownMenu">
              <li>
                <Link>English</Link>
              </li>
              <li>
                <Link>Spanish</Link>
              </li>
              <li>
                <Link>French</Link>
              </li>
            </ul>
          )}
        </div>

        <div className="center">
          <div className="item">
            <span>
              <ShowOnLogin>
                <FaUserCircle size={16} />
                &nbsp;
                <NavLink to="/profile" className={activeLink}>
                  Profile
                </NavLink>
              </ShowOnLogin>
            </span>
          </div>

          <div className="item">
            <span>
              <AdminOnlyLink>
                | &nbsp;
                <NavLink to="/admin/home" className={activeLink}>
                  Admin
                </NavLink>
              </AdminOnlyLink>
            </span>
          </div>
        </div>

        <div className="left">
          {/* <div className="item">
            <MdLocationOn size={16} />
            <span>Anambra</span>
          </div>
          <div className="item">
            <WiDayCloudy size={16} />
            <span>21C</span>
          </div> */}
          <div className="item">
            <BiCalendar size={16} />
            <span>Today ({d})</span>
          </div>

          <div className="icons">
            <Link>
              <RiFacebookFill color="#3b5998" size={18} />
            </Link>
            <Link>
              <IoLogoWhatsapp color="#25D366" size={18} />
            </Link>
            <Link>
              <ImGooglePlus color="#d34836" size={18} />
            </Link>
            <Link>
              <FaYoutube color="#b00" size={18} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NavbarTop;
